
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M.8 3.8A2.9 2.9 0 013.7.9h6.65a2.9 2.9 0 012.05.85l4.951 4.95a2.9 2.9 0 01.85 2.05V21.2a2.9 2.9 0 01-2.9 2.9H3.7a2.9 2.9 0 01-2.9-2.9V3.8zm2.9 8.7a1.45 1.45 0 011.45-1.45h8.7a1.45 1.45 0 010 2.9h-8.7A1.45 1.45 0 013.7 12.5zm1.45 4.35a1.45 1.45 0 000 2.9h8.7a1.45 1.45 0 000-2.9h-8.7z","fill":"#A2A0BE"}})])
          )
        }
      }
    